import React from 'react';

import { Badge, Text } from '@change/ds-core-ui/next';

export const DecisionMakerResponse: React.FC<{ response: string | undefined }> = ({ response }) => {
	if (response)
		return (
			<div className="bg-fill-success-weaker border-stroke-success-strong border-l-4 p-4">
				<Text variant="body" className="text-sm italic">
					{response}
				</Text>
			</div>
		);

	return <Badge label="Awaiting Response" variant="neutral" iconOnly={false} className="w-fit font-normal" />;
};
